<template>
    <ResourceInput
        label="Lotus Notes Id"
        attribute="lotusNotesId"
    />
</template>
